import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Portlet, Form, Row, Col, Button } from '_zari/core'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'

const FormularioFormGroup = ({ idDocumentoContable, editarData, limpiarIdDocumento }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      beneficiarioPagoNumeroIdentificacion: editarData.beneficiarioPagoNumeroIdentificacion ?? '',
      beneficiarioPagoPais: editarData.beneficiarioPagoPais ?? '',
      beneficiarioPagoRazonSocial: editarData.beneficiarioPagoRazonSocial ?? '',
      codigoMoneda: editarData.codigoMoneda ?? '',
      creditoFiscalDua: editarData.creditoFiscalDua ?? '',
      creditoFiscalNumeroDocumento: editarData.creditoFiscalNumeroDocumento ?? '',
      creditoFiscalSerieDocumento: editarData.creditoFiscalSerieDocumento ?? '',
      creditoFiscalTipoDocumento: editarData.creditoFiscalTipoDocumento ?? '',
      modalidadServicioPrestado: editarData.modalidadServicioPrestado ?? '',
      montoDeduccion: editarData.montoDeduccion ?? '',
      montoImpuestoRetenido: editarData.montoImpuestoRetenido ?? '',
      montoRentaBruta: editarData.montoRentaBruta ?? '',
      montoRentaNeta: editarData.montoRentaNeta ?? '',
      montoRetencionIgv: editarData.montoRetencionIgv ?? '',
      montoTasaRetencion: editarData.montoTasaRetencion ?? '',
      noDomiciliadoDireccion: editarData.noDomiciliadoDireccion ?? '',
      noDomiciliadoNumeroIdentificacion: editarData.noDomiciliadoNumeroIdentificacion ?? '',
      noDomiciliadoPais: editarData.noDomiciliadoPais ?? '',
      noDomiciliadoRazonSocial: editarData.noDomiciliadoRazonSocial ?? '',
      tipoCambio: editarData.tipoCambio ?? '',
      tipoConvenioEvitarDobleImposicion: editarData.tipoConvenioEvitarDobleImposicion ?? '',
      tipoExoneracion: editarData.tipoExoneracion ?? '',
      tipoRenta: editarData.tipoRenta ?? '',
      valorAplicacionArticulo76: editarData.valorAplicacionArticulo76 ?? '',
      vinculoContribuyenteResidente: editarData.vinculoContribuyenteResidente ?? ''
    }
  }, [editarData])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      AsientoContableService.insertarInfoNoDomiciliado(idDocumentoContable, data)
        .then(() => {
          __zariContext.snack('success', 'El documento se ha actualizado satisfactoriamente.')
          limpiarIdDocumento()
        })
        .catch(() => {
          __zariContext.snack('error', 'No se pudo guardar el documento.')
          setSubmitting(false)
        })
    },
    [__zariContext, idDocumentoContable, limpiarIdDocumento]
  )

  return (
    <Portlet>
      <Portlet.Body>
        <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
          {({ isSubmitting, errors, touched, handleSubmit }) => (
            <Form>
              <Row>
                <Col md={6}>
                  <FormGroups.BeneficiarioPagoNumeroIdentificacionFormGroup
                    iTouched={touched.beneficiarioPagoNumeroIdentificacion}
                    iError={errors.beneficiarioPagoNumeroIdentificacion}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
                <Col md={6}>
                  <FormGroups.BeneficiarioPagoPaisFormGroup
                    iTouched={touched.beneficiarioPagoPais}
                    iError={errors.beneficiarioPagoPais}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroups.BeneficiarioPagoRazonSocialFormGroup
                    iTouched={touched.beneficiarioPagoRazonSocial}
                    iError={errors.beneficiarioPagoRazonSocial}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
                <Col md={6}>
                  <FormGroups.CodigoMonedaFormGroup iTouched={touched.codigoMoneda} iError={errors.codigoMoneda} fIsSubmitting={isSubmitting} />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroups.CreditoFiscalDuaFormGroup
                    iTouched={touched.creditoFiscalDua}
                    iError={errors.creditoFiscalDua}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
                <Col md={6}>
                  <FormGroups.CreditoFiscalNumeroDocumentoFormGroup
                    iTouched={touched.creditoFiscalNumeroDocumento}
                    iError={errors.creditoFiscalNumeroDocumento}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroups.CreditoFiscalSerieDocumentoFormGroup
                    iTouched={touched.creditoFiscalSerieDocumento}
                    iError={errors.creditoFiscalSerieDocumento}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
                <Col md={6}>
                  <FormGroups.CreditoFiscalTipoDocumentoFormGroup
                    iTouched={touched.creditoFiscalTipoDocumento}
                    iError={errors.creditoFiscalTipoDocumento}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroups.ModalidadServicioPrestadoFormGroup
                    iTouched={touched.modalidadServicioPrestado}
                    iError={errors.modalidadServicioPrestado}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
                <Col md={6}>
                  <FormGroups.MontoDeduccionFormGroup iTouched={touched.montoDeduccion} iError={errors.montoDeduccion} fIsSubmitting={isSubmitting} />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroups.MontoImpuestoRetenidoFormGroup
                    iTouched={touched.montoImpuestoRetenido}
                    iError={errors.montoImpuestoRetenido}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
                <Col md={6}>
                  <FormGroups.MontoRentaBrutaFormGroup
                    iTouched={touched.montoRentaBruta}
                    iError={errors.montoRentaBruta}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroups.MontoRentaNetaFormGroup iTouched={touched.montoRentaNeta} iError={errors.montoRentaNeta} fIsSubmitting={isSubmitting} />
                </Col>
                <Col md={6}>
                  <FormGroups.MontoRetencionIgvFormGroup
                    iTouched={touched.montoRetencionIgv}
                    iError={errors.montoRetencionIgv}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroups.MontoTasaRetencionFormGroup
                    iTouched={touched.montoTasaRetencion}
                    iError={errors.montoTasaRetencion}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
                <Col md={6}>
                  <FormGroups.NoDomiciliadoDireccionFormGroup
                    iTouched={touched.noDomiciliadoDireccion}
                    iError={errors.noDomiciliadoDireccion}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroups.NoDomiciliadoNumeroIdentificacionFormGroup
                    iTouched={touched.noDomiciliadoNumeroIdentificacion}
                    iError={errors.noDomiciliadoNumeroIdentificacion}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
                <Col md={6}>
                  <FormGroups.NoDomiciliadoPaisFormGroup
                    iTouched={touched.noDomiciliadoPais}
                    iError={errors.noDomiciliadoPais}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroups.NoDomiciliadoRazonSocialFormGroup
                    iTouched={touched.noDomiciliadoRazonSocial}
                    iError={errors.noDomiciliadoRazonSocial}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
                <Col md={6}>
                  <FormGroups.TipoCambioFormGroup iTouched={touched.tipoCambio} iError={errors.tipoCambio} fIsSubmitting={isSubmitting} />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroups.TipoConvenioEvitarDobleImposicionFormGroup
                    iTouched={touched.tipoConvenioEvitarDobleImposicion}
                    iError={errors.tipoConvenioEvitarDobleImposicion}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
                <Col md={6}>
                  <FormGroups.TipoExoneracionFormGroup
                    iTouched={touched.tipoExoneracion}
                    iError={errors.tipoExoneracion}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroups.TipoRentaFormGroup iTouched={touched.tipoRenta} iError={errors.tipoRenta} fIsSubmitting={isSubmitting} />
                </Col>
                <Col md={6}>
                  <FormGroups.ValorAplicacionArticulo76FormGroup
                    iTouched={touched.valorAplicacionArticulo76}
                    iError={errors.valorAplicacionArticulo76}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroups.VinculoContribuyenteResidenteFormGroup
                    iTouched={touched.vinculoContribuyenteResidente}
                    iError={errors.vinculoContribuyenteResidente}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12} className='text-right'>
                  <Button disabled={isSubmitting} onClick={handleSubmit}>
                    Procesar
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(FormularioFormGroup)
